import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import './RootModal.css';
import BiopedModal from './BioPedModal';

let rootModalInstance = null;
let instanceId = 0;
let modalId = 0;

export default class RootModal extends Component {
    constructor (props) {
        super(props);
        this.id = instanceId++;
        this.state = {};
    }

    componentDidMount () {
        if (rootModalInstance === null) {
            rootModalInstance = this;
        }
    }

    componentWillUnmount () {
        if (rootModalInstance && rootModalInstance.id === this.id) {
            rootModalInstance = null;
        }
    }

    addModal (options) {
        this.setState(options);
    }

    removeModal(id) {
        delete this.state[id];
        this.setState(this.state);
    }

    getNewModalId() {
        return modalId++;
    }

    static RefModal(modal) {

    }

    static InitRootModal () {
        if (rootModalInstance === null) {
            const p = document.createElement('div');
            document.body.appendChild(p);
            ReactDOM.render(<RootModal />, p)
        }
    }

    static ShowModal(content, id, props) {
        this.InitRootModal();
        if (rootModalInstance) {
            id = id || rootModalInstance.getNewModalId();
            const opt = {};
            opt[id] = {content, props};
            console.log('Show Modal:', opt[id]);
            rootModalInstance.addModal(opt);
            return id;
        }
    }

    static CloseModal(id) {
        this.InitRootModal();
        if (rootModalInstance) {
            id = id || Object.keys(rootModalInstance.state).pop();
            rootModalInstance.removeModal(id);
            return id;
        }
    }

    render() {
        const modals = [];
        for (let p in this.state) {
            const m = this.state[p];
            modals.push(<BiopedModal key={p} modalId={p} isOpen={true} {... m.props}>{m.content}</BiopedModal>);
        }
        if (modals.length) {
            return (modals);
        }
        return null;
    }
}



// WEBPACK FOOTER //
// ./src/components/RootModal.jsx